var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fade-in-fwd" }, [
    _c(
      "div",
      {
        staticClass: "mt-5",
        class: _vm.isMobile ? "custom-container" : "container"
      },
      [
        _c("h6", { staticClass: "font-weight-bold" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$resourceString["myProject.Project.AddItemModal.Title"]
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "wf-modal-button-close btn button-full",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.closeModal()
              }
            }
          },
          [
            _c("span", {
              staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
              attrs: { "aria-label": "Close modal" }
            })
          ]
        ),
        _vm._v(" "),
        _vm.getContentWizardData.step !== 1
          ? _c("div", [
              _c("div", { staticClass: "my-project stepper-container row" }, [
                _c(
                  "ul",
                  {
                    staticClass:
                      "stepper d-flex justify-content-center ml-3 mr-3"
                  },
                  [
                    _vm._l(Object.entries(_vm.stepHeaders), function(ref) {
                      var stepIndex = ref[0]
                      var header = ref[1]
                      return _c(
                        "li",
                        { key: header, class: _vm.getClassName(stepIndex) },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$resourceString[header]) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.getContentWizardData.isOutOfProject
                      ? _c(
                          "li",
                          {
                            class:
                              _vm.getLastStep &&
                              _vm.getContentWizardData.isOutOfProject
                                ? "active"
                                : ""
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "contentWizard.Label.ChooseProject"
                                  ]
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  2
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getContentWizardData.step === 1
          ? _c("div", [_c("step-one")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getContentWizardData.contentItem.type ==
          _vm.CustomContentItemTypes.webPage &&
        _vm.getContentWizardData.step == 2
          ? _c("div", [_c("stepWebPage")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getLastStep && _vm.getContentWizardData.isOutOfProject
          ? _c("div", [_c("choose-project")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getContentWizardData.contentItem.type ==
          _vm.CustomContentItemTypes.product &&
        _vm.getContentWizardData.step == 2
          ? _c("div", [_c("step-two")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getContentWizardData.contentItem.type ==
          _vm.CustomContentItemTypes.product &&
        _vm.getContentWizardData.step == 3
          ? _c("div", [_c("step-three")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getContentWizardData.contentItem.type ==
          _vm.CustomContentItemTypes.product &&
        _vm.getContentWizardData.step == 4
          ? _c("div", [_c("step-four")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getContentWizardData.contentItem.type ==
          _vm.CustomContentItemTypes.virtualTray &&
        _vm.getContentWizardData.step == 2
          ? _c("div", [_c("vtStep")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getContentWizardData.contentItem.type ==
          _vm.CustomContentItemTypes.virtualTray &&
        _vm.getContentWizardData.step == 3
          ? _c("div", [_c("project-Editcontent-Item")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getContentWizardData.contentItem.type ==
          _vm.CustomContentItemTypes.customPattern &&
        _vm.getContentWizardData.step == 2
          ? _c("div", [_c("step-two")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getContentWizardData.contentItem.type ==
          _vm.CustomContentItemTypes.customPattern &&
        _vm.getContentWizardData.step == 4
          ? _c("div", [_c("step-four")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getContentWizardData.contentItem.type ==
          _vm.CustomContentItemTypes.galleryImages &&
        _vm.getContentWizardData.step == 2
          ? _c("div", [_c("gallery-Images-Step-Two")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getContentWizardData.contentItem.type ==
          _vm.CustomContentItemTypes.galleryImages &&
        _vm.getContentWizardData.step == 3
          ? _c("div", [_c("gallery-Images-Step-Three")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getContentWizardData.contentItem.type ==
          _vm.CustomContentItemTypes.addDocument &&
        _vm.getContentWizardData.step == 2
          ? _c("div", [_c("add-document-Step-Two")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getContentWizardData.contentItem.type ==
          _vm.CustomContentItemTypes.addDocument &&
        _vm.getContentWizardData.step == 3
          ? _c("div", [_c("add-document-Step-Three")], 1)
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer border-0 pl-gutter pr-gutter" }, [
      _c("div", { staticClass: "justify-content-between w-100 row" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-primary",
            on: {
              click: function($event) {
                return _vm.closeModal()
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$resourceString["virtualtray.Savetray.Cancel.Button"]
                ) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c("span", [
          _vm.getContentWizardData.step !== 1
            ? _c(
                "button",
                {
                  staticClass: "btn btn-outline-primary mx-2",
                  on: { click: _vm.handleBack }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$resourceString["common.Button.Back"]) +
                      "\n        "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.getContentWizardData.step !== 1 && !_vm.getLastStep
            ? _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { disabled: _vm.getDisabled() },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.handleNext($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$resourceString["common.button.next"]) +
                      "\n        "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.getLastStep
            ? _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { disabled: _vm.getDisabled() },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.addProjectItem($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$resourceString[
                          "myProject.Project.AddItemModal.Button.AddToProject"
                        ]
                      ) +
                      "\n        "
                  )
                ]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }